// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "parse-perf-worker" + "-" + "e6ca998dfed0d1179608" + ".chunk.min.js";
};